import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persistedstate'
import { createI18n } from 'vue-i18n'
import { createToastflow } from 'vue-toastflow'

import en from '@/translations/en.json' with { type: 'json' }
import de from '@/translations/de.json' with { type: 'json' }
import da from '@/translations/da.json' with { type: 'json' }
import kr from '@/translations/kr.json' with { type: 'json' }

import router from './router'

import App from './App.vue'
import '@/assets/styles/main.css'

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, de, da, kr },
})

const store = createPinia()
store.use(piniaPersist)

const notifications = createToastflow({
  position: 'bottom-right',
  alignment: 'left',
  offset: '8px',
  overflowScroll: true,
  duration: 10000,
  pauseOnHover: true,
  swipeToDismiss: true,

  showCreatedAt: true,
  createdAtFormatter: (createdAt) =>
    new Date(createdAt).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    }),
})

const app = createApp(App)

app
  .use(store)
  .use(router)
  .use(i18n)
  .use(notifications)

app.mount('#app')
